import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-star-achievers',
  templateUrl: './star-achievers.component.html',
  styleUrls: ['./star-achievers.component.scss']
})
export class StarAchieversComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  scrollToForm(idSelector: string): void {
    document.getElementById(idSelector).scrollIntoView({'behavior':'smooth'});
  }

}



// WEBPACK FOOTER //
// ./src/app/star-achievers/star-achievers.component.ts